export default __webpack_public_path__ + "static/media/Icon menu Attendance _ Inactive.a62e6006.svg";